module.exports = __webpack_public_path__ + "assets/files/Terms_conditions.4a33b33c.pdf";